module.exports = __webpack_public_path__ + "img/12.74947a2.74947a20.png";